<script setup lang="ts">
  import TrashIcon from '@/shared/assets/icons/TrashIcon.svg';
  import { formatDocumentPrefix } from '@/shared/lib';
  import { DefaultTable, IconImage, TableHeader } from '@/shared/ui';

  import type { SelectedGdDocument } from '../model/useGdDocumentSelection';

  defineProps<{
    documents: SelectedGdDocument[];
  }>();

  const emit = defineEmits<{
    (e: 'remove', revisionId: number): void;
  }>();

  const formatRevisionLabel = (revision: number) => String(revision).padStart(2, '0');
</script>

<template>
  <DefaultTable
    v-if="documents.length > 0"
    data-testid="selected-gd-documents-list"
  >
    <colgroup>
      <col class="w-40">
      <col>
      <col class="w-24">
      <col class="w-24">
    </colgroup>
    <thead>
      <tr>
        <TableHeader text="Prefixo" />
        <TableHeader
          text="Título"
          th-class="px-4 py-4.5 text-left text-xs font-semibold text-gray-07"
        />
        <TableHeader
          text="Rev."
          th-class="px-4 py-4.5 text-left text-xs font-semibold text-gray-07"
        />
        <TableHeader
          text="Ações"
          th-class="px-6 py-4.5 text-right whitespace-nowrap text-xs font-semibold text-gray-07"
        />
      </tr>
    </thead>

    <tbody class="divide-y divide-gray-02 border-t border-gray-02 bg-white-01">
      <tr
        v-for="document in documents"
        :key="document.id"
        :data-testid="`selected-gd-document-${document.id}`"
      >
        <td class="py-4.5 pl-6 pr-4 text-sm text-gray-07">
          {{ formatDocumentPrefix(document.prefix) }}
        </td>
        <td class="px-4 py-4.5 text-sm text-gray-07">
          {{ document.title ?? 'Sem título' }}
        </td>
        <td class="px-4 py-4.5 text-sm text-gray-07">
          {{ formatRevisionLabel(document.revision) }}
        </td>
        <td class="px-6 py-4.5">
          <div class="flex items-center justify-end">
            <button
              type="button"
              class="inline-flex items-center justify-center text-gray-xx-02 transition-colors hover:text-red-16"
              :data-testid="`remove-gd-document-${document.id}`"
              @click="emit('remove', document.id)"
            >
              <IconImage
                :src="TrashIcon"
                alt="Remover documento selecionado"
                class="h-6 w-6"
              />
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </DefaultTable>
</template>
